import lazyLoadOnRender from '../../lazy/loadOnRender';

export default lazyLoadOnRender({
  loader: async () => {
    const { InboxActionButton } = await import(
      /* webpackChunkName: "4-feat-vivaengageappinbox" */ '@ms/yammer-features-app-navigation'
    );

    return { default: InboxActionButton };
  },
});
